import '/Users/adriancerdeira/Documents/webroot/sva-corporate-webseite/DistributionPackages/Ongoing.NodeTypes.News/NodeTypes/Content/News/List/List.js';

/*
// Hide LoadMore if nothing to Load
function hideLoadmoreNews() {

    $(".ongoing-nodetypes-news-news-list .loadMore").each(function () {

        // Get Variables
        var $section = $(this).parents(".section");
        var $cardContainer = $($section).find('.ongoing-nodetypes-news-news-list');
        var cardsHidden = $($cardContainer).find('.news-element:hidden');
        var cardsUpdateCount = $($cardContainer).data('visible-'+$('body').data('mediaquery'));

        if (cardsHidden.length <= 0) {
            console.log(cardsHidden.length, cardsUpdateCount);
            $(this).parent().hide();
        }
    });
}

$(window).on("load", function () {
    hideLoadmoreNews();
});
$(window).on("resize", function () {
    hideLoadmoreNews();
});

// Load More
$(".ongoing-nodetypes-news-news-list .loadMore").on("click", function (e) {

    // Disable Link
    e.preventDefault();
    e.stopPropagation();

    // Get Variables
    var $section = $(this).parents(".section");
    var $cardContainer = $($section).find('.ongoing-nodetypes-news-news-list');
    var cardsHidden = $($cardContainer).find('.news-element:hidden');
    var cardsUpdateCount = $($cardContainer).data('visible-'+$('body').data('mediaquery'));

    // Show next X Cards
    $(cardsHidden).slice(0,cardsUpdateCount).show();

    // Hide load more if no more Elements
    hideLoadmoreNews();

});
*/

$(document).ready(() => {
    $('.copytoclipboard').click(function () {
        let text = this.getAttribute('data-url');
        // Fallback, deprecated copy
        if (!navigator.clipboard) {
            fallbackCopy(text);
            return;
        }
        // Correct, Secure copy
        navigator.clipboard.writeText(text);
    });
});

function fallbackCopy(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
    } catch (err) {
    }
    document.body.removeChild(textArea);
}
